<script lang="ts" setup>
import { breakpointsTailwind } from '@vueuse/core';
import type { AgentOnPage } from '@@/shared/agent/api-types';

const props = defineProps<{
  title: string
  agent: AgentOnPage
}>();

const open = ref(false);
const head = useLocaleHead();
const agentLink = computed(() => head.value.meta?.find((meta: Record<string, string>) => meta.property === `og:url`)?.content);

const breakpoints = useBreakpoints(breakpointsTailwind);
const smallScreens = breakpoints.smaller(`md`);
const { share, isSupported } = useShare();

function onShare() {
  if (!smallScreens.value) return openShareDialog();
  if (!isSupported.value) return openShareDialog();
  share({
    title: props.title,
    url: agentLink.value,
  });
}

function openShareDialog() {
  open.value = true;
}
</script>

<template>
  <div class="content">
    <IadBtn
      variant="outlined"
      icon
      @click="onShare"
    >
      <Icon name="iad-icon:share" />
    </IadBtn>

    <ClientOnly>
      <AgentDialogShare
        v-model="open"
        :agent
        @close="open = false"
      />
    </ClientOnly>
  </div>
</template>
